/**
 * Company facts shared by the policy pages. Routes, absolute URLs, and policy
 * versions live in the cross-app source of truth (`@admin-platform/shared`);
 * re-exported here so the legal pages can keep importing from one local module.
 */

import { POLICY_VERSIONS } from '@admin-platform/shared/constants';

export {
  LEGAL_ROUTES,
  LEGAL_URLS,
  SITE_ORIGIN,
  POLICY_VERSIONS,
  POLICY_TYPES,
} from '@admin-platform/shared/constants';
export type { PolicyType } from '@admin-platform/shared/constants';

export const COMPANY = {
  legalName: 'AcceleratorApp Limited',
  jurisdiction: 'the British Virgin Islands',
  companyNumber: 'BVI Company No. 1991045',
  privacyEmail: 'privacy@revvly.ai',
  legalEmail: 'legal@revvly.ai',
  securityEmail: 'security@revvly.ai',
} as const;

/**
 * Page-level dates, derived from the per-policy version metadata so they can't
 * drift from `POLICY_VERSIONS`. All three launched together, so any policy's
 * effectiveDate is representative.
 */
export const LEGAL_DATES = {
  effective: POLICY_VERSIONS.TERMS.effectiveDate,
  lastUpdated: POLICY_VERSIONS.TERMS.effectiveDate,
} as const;
